import PlaylistCategory from './PlaylistCategory';

export default PlaylistCategory;
